import React from "react";
import { useNavigate } from "react-router-dom";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

import { extractDate } from "../../../Components/Functions/date.fun";
const tableHead = [
  "Followup Date",
  "full name",
  // "contact number",
  // "filtered by",
  "lead owner",
  // "interested In",
  // "Reassign",
  "Notes",
  "Actions",
];

function checkDateStatus(dateString) {
  const inputDate = new Date(dateString);
  const currentDate = new Date();
  const differenceMilliseconds = currentDate - inputDate;
  const differenceDays = differenceMilliseconds / (1000 * 3600 * 24);

  if (differenceDays <= 1) {
    return "superhot";
  } else if (differenceDays > 1 && differenceDays <= 4) {
    return "hot";
  } else if (differenceDays > 4 && differenceDays <= 7) {
    return "warmer";
  } else if (differenceDays > 7 && differenceDays <= 10) {
    return "warm";
  } else if (differenceDays > 10 && differenceDays <= 13) {
    return "colder";
  } else {
    return "cold";
  }
}
const getBackgroundStyleByDate = (dateString) => {
  let style = {};
  if (checkDateStatus(dateString) === "superhot") {
    style = {
      backgroundColor: "rgb(12, 166, 120,0.1)",
    };
    return style;
  } else if (checkDateStatus(dateString) === "hot") {
    style = {
      backgroundColor: "rgba(0,255,0,0.1)",
    };
    return style;
  } else if (checkDateStatus(dateString) === "warmer") {
    style = {
      backgroundColor: "rgb(116, 184, 22,0.1)",
    };
    return style;
  } else if (checkDateStatus(dateString) === "warm") {
    style = {
      backgroundColor: "rgb(245, 159, 0,0.1)",
    };
    return style;
  } else if (checkDateStatus(dateString) === "colder") {
    style = {
      backgroundColor: "rgb(247, 103, 7,0.1)",
    };
    return style;
  } else {
    style = {
      backgroundColor: "rgba(255,0,0,0.1)",
    };
    return style;
  }
};
const getFollowupDate = (list) => {
  if (list[list.length - 1]?.followUpDate) {
    return list[list.length - 1]?.followUpDate;
  }
  return "N/A";
};

const getFollowupMessage = (list) => {
  if (list[list.length - 1]?.followUp) {
    return list[list.length - 1]?.followUp;
  }
  return "N/A";
};
const FollowupLeadsTable = ({ leads = [], ReassignLead }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/leads-followup/view/${id}`);
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => (
              <th key={index}>{item}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {leads?.map((item, index) => {
            return (
              <tr
                key={item?.id}
                style={
                  item?.createdAt &&
                  getBackgroundStyleByDate(extractDate(item?.createdAt))
                }
              >
                <td>
                  {item?.followUp && item?.followUp?.length > 0
                    ? getFollowupDate(item?.followUp)
                    : "N/A"}
                </td>
                {/* <td>{item?.createdAt}</td> */}
                <td style={{ maxWidth: "200px" }}>
                  <span
                    className="cursor-pointer text-blue text-decoration-underline"
                    onClick={() => goToView(item.id)}
                  >
                    {item?.full_name || "N/A"}
                  </span>
                  <br />
                  <span className="text-secondary">
                    {item?.phone_number || "N/A"}
                  </span>
                </td>
                {/* <td>
                  {item?.full_name || "N/A"} <br />{" "}
                  <span className="text-secondary badge bg-cyan-lt">
                    {item?.phone_number || "N/A"}
                  </span>
                </td> */}
                {/* <td>{item?.phone_number || "N/A"}</td> */}
                {/* <td>{item?. || "N/A"}</td> */}
                <td>{item?.lead_alloted_to || "N/A"}</td>

                <td>
                  {item?.followUp && item?.followUp?.length > 0
                    ? getFollowupMessage(item?.followUp)
                    : "N/A"}
                </td>

                {/* <td>
                  <button
                    disabled={item.reAssignTo}
                    style={{ width: "70px", height: "30px" }}
                    className="btn btn-primary"
                    onClick={() => ReassignLead(item)}
                  >
                    Re Assign
                  </button>
                </td> */}

                <td>
                  <CustomViewButton onClick={() => goToView(item.id)} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default FollowupLeadsTable;
